import React, { Component, useEffect, useState } from 'react';
import Layout from '../../core/layouts/main/index';
import SideOverlay from '../../core/layouts/main/side-overlay/side-overlay';
import Loading from '../../core/layouts/main/loading/loading';
import UsersReport from './components/UsersReport';
import Storage from '../../core/config/helpers/Storage';
import { AccountController } from '../../core/config/controllers/AccountController';
import { VehicleController } from '../../core/config/controllers/VehicleController';

export default function Home() {
  const [sidebarOpen, setSideBarOpen] = useState(false);
  const [configuration, setConfiguration] = useState({
    boatTypes: [
      {},
      {},
      {},
    ]
  })
  const [data, setData] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    Storage.isAuthenticated();
    AccountController.List((res) => {
      if (res) {
        setData(res);
      }
    });
    VehicleController.List((res) => {
      if (res) {
        console.log("Vehicles loaded:", res);
        setVehicles(res);
      }
    });
  }, []);

  function ResumeCard({title, hint, value}){
    return (
      <a
      className="border-left border-success border-3x block block-rounded block-link-pop"
      href="javascript:void(0)"
    >
      <div className="block-header">
        <div className="block-title">{value} {title}</div>
        <div className="block-tools">
          {hint != undefined ? (
            <button className="btn btn-dual" title={hint}>
              <i className="far fa-question-circle" />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* <div className="block-content block-content-full d-flex align-items-center justify-content-between">
        <div className="ml-3 text-center">
          <p className="font-size-h3 font-w300 mb-0">{value}</p>
        </div>
      </div> */}
    </a>
    )
  }

  return (
    <Layout showSideOverlay={sidebarOpen}>
      <div className="content">
        <div class="row mb-2">
          <div className='col-md-6'>
            <ResumeCard title={"Usuários"} hint={"Usuários cadastrados na plataforma"} value={data.length}/>
          </div>
          <div className='col-md-6'>
            <ResumeCard title={"Veículos"} hint={"Veículos rastreados na plataforma"} value={vehicles.length}/>
          </div>
          <div className='col-md-12'>
            <UsersReport/>
          </div>
        </div>
      </div>
      <Loading loading={loading} />
      {/* <SideOverlay title="Opções">CONTEÚDOOOOO</SideOverlay> */}
    </Layout>
  );

};